import React from 'react';
import PropTypes from 'prop-types';
import FeaturedImage from '../FeaturedImage';
import useSettingsContext from '../../context/useSettingsContext';
import useDataContext from "../../context/useDataContext";

function Post(props) {
  const {
    postType,
    displayAuthor,
  } = useSettingsContext();

  const {
    globalData
  } = useDataContext();

  const {post} = props;
  let categoryItem;
  let featuredImage;
  let author;
  const thumb_img = post.featured_image || globalData.post_img_placeholder

  Post.propTypes = {
    post: PropTypes.object
  }

  if (thumb_img) {
    featuredImage = <a href={post.link} className="latest-post__link">
      <figure className="latest-post__img">
        <FeaturedImage
          imageSize={'blog-thumb'}
          image={thumb_img}
          srcset={thumb_img}
        />
      </figure>
    </a>
  }

  if (post.the_categories !== undefined && post.the_categories.length > 0) {
    const category = post.the_categories[0];
    categoryItem =
        <a
          key={category.id}
          href={category.link}
          className={`eight29-taxonomy-${category.taxonomy}`}
        >{category.name}</a>
  }

  if (post.the_author !== undefined && displayAuthor) {
    author = <h4  className="latest-post__author">By {post.the_author}</h4>
  }

  return (
    <article id={`${postType}-${post.id}`} className="latest-post latest-post--single">
      {featuredImage}

      <div className="latest-post__content">
        <h4 className="latest-post__cat">
         {categoryItem}
        </h4>

        <h3 className="latest-post__title"><a className={'latest-post__link'} href={post.link} dangerouslySetInnerHTML={{__html: post.title.rendered}}/></h3>

        {author}
      </div>
    </article>
  );
}

export default Post;
